import React from 'react'
import MainContainer from '../MainContainer'
import ViewContent from './ViewContent'

export default function View() {
  return (
    <MainContainer actived={["result"]}>
       <ViewContent />
    </MainContainer>
  )
}
